const createTooltipPropObject = tooltipPosition => {
  const [position, arrow] = tooltipPosition.split('-');
  const oppositePositions = {
    top: 'bottom',
    bottom: 'top',
    right: 'left',
    left: 'right'
  };
  const newArrowPosition = `${oppositePositions[position]}-${arrow || 'center'}`;
  return {
    position: position,
    arrowPosition: newArrowPosition
  };
};
var createTooltipPropObject$1 = createTooltipPropObject;

export { createTooltipPropObject$1 as default };
//# sourceMappingURL=getTooltipProp.js.map
